import { generateTheme } from '@talpanetwork/talpa-publishing-theme/theming/generateTheme';

import palettes from './palettes';
import breakpoints from './breakpoints';
import zIndexes from './zIndexes';

const theme = (palette = 'default') =>
  generateTheme({
    palette: palettes[palette] || palettes.default,
    breakpoints,
    zIndex: zIndexes,
  });

export default theme;
